"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUuidv4 = void 0;
const generateUuidv4 = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
  const r = Math.random() * 16 | 0;
  const v = c == 'x' ? r : r & 0x3 | 0x8;
  return v.toString(16);
});
exports.generateUuidv4 = generateUuidv4;